export const nordrheinWestfalen = {
  slug: "nordrhein-westfalen",
  name: "Nordrhein-Westfalen (NRW)",
  hero: {
    eyebrow: "Bundesland-Übersicht",
    title: "Erdwärme in Nordrhein-Westfalen",
    subtitle:
      "Kurze, praxisnahe Übersicht zu Förderung, Genehmigungen, Datenlage und typischen Standortthemen – als Einstieg vor Planung und Angeboten.",
    infoBox:
      "Hinweis: NRW bietet mit dem Geothermie-Portal und dem Informationssystem Geothermie sehr gute Grundlagen für die Vorprüfung. Wasser- und bergrechtliche Fragen bleiben dennoch standortabhängig.",
  },
  seo: {
    title:
      "Erdwärme in NRW – Förderung, Genehmigung & Geothermie-Portal | Erdwärme-Experten",
    description:
      "Kurzübersicht für Erdwärme in NRW: KfW-Förderung, wasserrechtliche Erlaubnis, Geothermie-Portal NRW, Erdwärmepotenzial und Hinweise zu Bohrungen und Untergrund.",
    canonical: "https://www.erdwaerme-experten.de/bundeslaender/nordrhein-westfalen",
  },

  facts: [
    {
      title: "Förderung (Bund)",
      icon: "BadgeCheck",
      color: "from-rose-600 to-rose-500",
      bullets: [
        "Heizungstausch-Zuschuss über KfW Programm 458 für Bestandsgebäude",
        "30 % Grundförderung; persönliche Boni können die Quote erhöhen",
        "Maximal 80 %; kein separater Effizienzbonus für Erdwärme",
      ],
      note:
        "Förderstand 21.07.2026. Die tatsächliche Förderfähigkeit hängt von Gebäude, Eigentum, Einkommen und weiteren Voraussetzungen ab.",
      link: {
        label: "KfW 458 (offiziell)",
        href: "https://www.kfw.de/inlandsfoerderung/Privatpersonen/Bestehende-Immobilie/F%C3%B6rderprodukte/Heizungsf%C3%B6rderung-f%C3%BCr-Privatpersonen-Wohngeb%C3%A4ude-%28458%29/",
      },
    },
    {
      title: "Genehmigung & Zuständigkeiten",
      icon: "ShieldCheck",
      color: "from-slate-700 to-slate-600",
      bullets: [
        "Für Erdwärmesonden auf demselben Grundstück ist eine wasserrechtliche Erlaubnis der unteren Wasserbehörde erforderlich",
        "Bohrungen tiefer als 100 m sind der Bergbehörde vorab anzuzeigen",
        "Je nach Fall sind zusätzlich bergrechtliche Anforderungen zu prüfen",
      ],
      note:
        "NRW trennt die Zuständigkeiten vergleichsweise klar zwischen Wasserbehörde und Bergbehörde.",
      link: {
        label: "Geologischer Dienst NRW – Oberflächennahe Geothermie",
        href: "https://www.gd.nrw.de/ew_og.htm",
      },
    },
    {
      title: "Datenlage & Standortcheck",
      icon: "Layers",
      color: "from-indigo-700 to-indigo-600",
      bullets: [
        "Im Geothermie-Portal NRW gibt es kostenfrei Angaben zum geothermischen Potenzial des Untergrunds",
        "Für die oberflächennahe Geothermie werden Standorte für Kollektoren bis 2 m und Sonden bis 100 m adressiert",
        "Für die Detailplanung von Erdwärmesonden bis 1.000 m stehen im Portal umfangreiche geologische Daten bereit",
      ],
      note:
        "NRW gehört damit zu den Bundesländern mit besonders guter Datenbasis für eine Vorprüfung.",
      link: {
        label: "Geothermie-Portal NRW",
        href: "https://gd.nrw.de/ew_gp.htm",
      },
    },
    {
      title: "Untergrund & typische Praxis",
      icon: "Drill",
      color: "from-emerald-700 to-emerald-600",
      bullets: [
        "Das Erdwärmepotenzial bis 100 m Tiefe ist in weiten Teilen von NRW gut bis sehr gut",
        "Typische Tiefen für Erdwärmesonden liegen laut GD NRW häufig bei etwa 40–150 m",
        "Abstände zu Grundstücksgrenzen und zwischen Sonden sind bei der Planung relevant",
      ],
      note:
        "Für die konkrete Auslegung zählen trotzdem immer die lokalen hydrogeologischen und wasserwirtschaftlichen Bedingungen.",
      link: {
        label: "Oberflächennahe Geothermie in NRW",
        href: "https://www.gd.nrw.de/ew_og.htm",
      },
    },
  ],

  dataCards: [
    {
      title: "Welche Daten sind in NRW besonders stark?",
      icon: "Layers",
      desc:
        "Geothermie-Portal NRW, Erdwärmepotenzial, geologische Daten für die Vorplanung und zusätzliche Wasserdaten über ELWAS-WEB.",
    },
    {
      title: "Was ist häufig der Engpass?",
      icon: "ThermometerSun",
      desc:
        "Nicht nur das Potenzial, sondern die wasserrechtliche Zulässigkeit, lokale Grundwasserbedingungen und bei tieferen Bohrungen bergrechtliche Fragen.",
    },
    {
      title: "Was macht euer GeoReport konkret?",
      icon: "FileText",
      desc:
        "Zusammenführung der verfügbaren Standortdaten mit erster Dimensionierung, Kosten- und Förderlogik – als Vorentscheidung vor Fachplanung und Angebotseinholung.",
    },
  ],

  faq: [
    {
      q: "Brauche ich in NRW eine wasserrechtliche Erlaubnis für Erdwärmesonden?",
      a: "Ja, für Erdwärmesondenanlagen, die Erdwärme auf demselben Grundstück gewinnen und nutzen, benötigen Eigentümer in NRW grundsätzlich eine wasserrechtliche Erlaubnis der zuständigen unteren Wasserbehörde.",
      links: [
        {
          label: "Geologischer Dienst NRW – Oberflächennahe Geothermie",
          href: "https://www.gd.nrw.de/ew_og.htm",
        },
      ],
    },
    {
      q: "Wo kann ich in NRW mein Grundstück vorab prüfen?",
      a: "Dafür ist das Geothermie-Portal NRW sehr hilfreich. Dort gibt es kostenfrei Angaben zum geothermischen Potenzial des Untergrunds und Daten für die Vorplanung.",
      links: [
        {
          label: "Geothermie-Portal NRW",
          href: "https://gd.nrw.de/ew_gp.htm",
        },
      ],
    },
    {
      q: "Was gilt in NRW bei tieferen Bohrungen?",
      a: "Bohrungen tiefer als 100 Meter sind der Bergbehörde vorab anzuzeigen. Je nach Projekt können zusätzliche bergrechtliche Anforderungen relevant werden.",
      links: [
        {
          label: "Oberflächennahe Geothermie in NRW",
          href: "https://www.gd.nrw.de/ew_og.htm",
        },
        {
          label: "LANUV-Arbeitsblatt 39",
          href: "https://www.lanuv.nrw.de/fileadmin/lanuvpubl/4_arbeitsblaetter/LANUV-Arbeitsblatt_39.pdf",
        },
      ],
    },
  ],

  cta: {
    title: "NRW-Standort prüfen (datenbasiert)",
    text:
      "Du bekommst eine standortbezogene Vorabschätzung: verfügbare Untergrunddaten, erste Dimensionierung, Kosten-/Förderlogik und Hinweise zu typischen Genehmigungsthemen – als Grundlage für die nächsten Schritte.",
    primary: {
      label: "Jetzt Standort-Report erstellen",
      href: "/report",
      title: "Erdwärme Standort-Report für NRW erstellen",
    },
    secondary: { label: "Erst Grundlagen ansehen", href: "/flache-geothermie" },
    footnote:
      "Tipp: NRW ist für eine datenbasierte Vorprüfung besonders geeignet, weil das Geothermie-Portal schon sehr früh eine gute Einordnung ermöglicht.",
  },
};